import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  radius,
  screen,
  spacing
} from '../../theme';

export const StyledJobOfferLongText = styled.div`
  max-width: ${container('md')};
  font-size: ${fontSize('md')};
  line-height: 1.6;
  margin-top: ${spacing('lg')};
  margin-left: auto;
  margin-right: auto;
  text-align: left;

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
  }

  ul {
    padding-left: 0 !important;
  }

  li {
    padding-left: 2rem !important;
    margin-left: 0 !important;
    margin-bottom: ${spacing('md')};
    position: relative;
    list-style-type: none !important;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 1.25rem;
      height: 1.25rem;
      background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='check-circle' class='svg-inline--fa fa-check-circle fa-w-16 ' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24px' height='24px'%3E%3Cpath fill='%23C0BEC9' d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z'%3E%3C/path%3E%3C/svg%3E%0A");
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: ${spacing('sm')};
      margin-top: 0.1em;

      @media (min-width: ${screen('lg')}) {
        width: ${spacing('lg')};
        height: ${spacing('lg')};
      }
    }
  }

  img {
    display: block;
    margin: 1rem auto;
    border: ${spacing('md')} solid ${color('text_default')};
    border-radius: ${radius('md')};
  }
`;
